import './pageFooter.css';

export function PageFooter() {
    return (
        <footer className="page-footer">
            <div className="footer-content">
                <div className="disclaimer-text">
                    O AF-Screen constitui uma ferramenta de rastreio clínico não validada. Não substitui avaliação neurológica completa, estudos eletrofisiológicos ou sequenciamento genético. As recomendações baseiam-se nas melhores práticas clínicas vigentes, podendo variar conforme infraestrutura disponível e protocolos institucionais. A responsabilidade decisória recai integralmente sobre o profissional aplicador, que deverá integrar os resultados deste formulário ao contexto clínico individual do paciente.
                </div>
                <div className="copyright-text">
                    &copy; Copyright {new Date().getFullYear()} Afya - Todos os direitos reservados
                </div>
            </div>
        </footer>
    );
}